import * as React from "react";
const ReviewStarHalfSolidIcon = (props) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", fill: "currentColor", width: "1em", height: "1em", ...props },
    React.createElement("path", { d: "M9.73 45 24 35.73 24.005 3l-6 14.885H3.002l11.612 10.518z" }));
export default ReviewStarHalfSolidIcon;
